export default {
  pureWhite: '#ffffff',
  wildSand: '#f5f5f5',
  gallery: '#eeeeee',
  mercury: '#e4e4e4',
  mercury01: '#e9e9e9',
  alto: '#d3d3d3',
  geyser: '#d5dadf',
  bombay: '#b5b9be',
  silver: '#cbcbcb',
  silver01: '#cbcbcb',
  silver02: '#b9b9b9',
  silverChalice: '#aaaaaa',
  silverChalice01: '#aaaaaa',
  silverChalice02: '#a8a8a8',
  silverChalice03: '#a0a0a0',
  'silver-chalice--05': 'rgba(168,168,168,0.5)', // transparentize(#a8a8a8, 0.5),
  gray: '#838383',
  boulder: '#7c7c7c',
  dove: '#666',
  tundora: '#464646',
  tundora01: '#464646',
  mineShaft: '#252525',
  athensGray: '#E6E9EC',

  pattensBlue: '#dbf1ff',
  iceberg: '#CFEAF1',
  onahau: '#caeaff',
  pictonBlue: '#3dc6f5',
  java: '#16a7cd',
  blueChill: '#1286a4',

  emerald: '#4bc88c',
  mantis: '#8ACF61',
  mustard: '#FFD754',
  teaGreen: '#D8F4C5',

  amber: '#FFC400',
  sun: '#f8b309',
  sushi: '#68BC37',
  champagne: '#FAEECB',

  azalea: '#f9d4d4',
  persimmon: '#ff6458',
  sunsetOrange: '#fa4747',
  flushMahogany: '#c83939',
  stiletto: '#962828',
  vividTangerine: '#FF8D84'
}
